/*
  A date an asset stores, written the way the reader expects to read it.

    en   MM/DD/YYYY
    fr   DD/MM/YYYY

  Deliberately not Utils/formatDate.js. That one writes English as YYYY/MM/DD
  and always appends a time, which is right for the timestamps it was made for
  and wrong for a date-only field on an asset.

  Storage is untouched: assets keep YYYY/MM/DD, the app-wide convention
  (Utils/isValidDateFormat.js) and the reason these values sort correctly as
  plain text. Only the reading changes — so whatever calls this must sort on
  the stored value, never on what comes back from here. Read as text,
  MM/DD/YYYY orders by month, which would put December 2024 above January 2026.
*/
export const formatStoredDate = (value, label) => {
  const text = String(value || "").trim();
  /*
    Handed back untouched when it is not the stored shape — an empty field, or
    a value from before the app settled on this format. Better to show what is
    there than to rearrange digits that might not mean what this assumes.
  */
  /*
    Either separator. Assets write YYYY/MM/DD, and the evaluation records that
    predate that convention hold YYYY-MM-DD; both mean the same day and both
    should be read the same way.
  */
  const parts = /^(\d{4})[/-](\d{2})[/-](\d{2})$/.exec(text);
  if (!parts) return text;
  const [, year, month, day] = parts;
  return label === "fr"
    ? `${day}/${month}/${year}`
    : `${month}/${day}/${year}`;
};
